export function smoothScroll(_a) {
  var _b = _a.enableSmoothScroll,
      enableSmoothScroll = _b === void 0 ? false : _b,
      pushStateBehavior = _a.pushStateBehavior;
  var anchorLinks = document.querySelectorAll('a[href^="#"]');

  var _loop_1 = function _loop_1(item) {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      var hashValue = item.getAttribute("href");
      var target = document.querySelector(hashValue);
      var scrollIntoView = target.scrollIntoView;

      if (enableSmoothScroll && scrollIntoView && typeof scrollIntoView === "function") {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      } else {
        var top_1 = 0;

        while (target) {
          top_1 += target.offsetTop;
          target = target.offsetParent;
        }

        window.scrollTo(0, top_1);
      }

      pushStateBehavior ? pushStateBehavior(hashValue) : window.history.pushState(null, "", hashValue);
    });
  };

  for (var _i = 0, _c = anchorLinks; _i < _c.length; _i++) {
    var item = _c[_i];

    _loop_1(item);
  }
}